/* eslint jsx-a11y/anchor-has-content:0 */
// TODO(markn): disabled this rule due to legal blocking using DLS
import { Text, InlineChildren, StackChildren } from '@doordash/design-language'
import * as React from 'react'
import styled from 'styled-components'

import LegalText from '../../atoms/legal-text'

import { Interpolate } from '@doordash/lib-i18n'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'
import { additionalDisclosure } from './strings'

const FAIR_CHANCE_ORDINANCE_NOTICE_URL =
  // tslint:disable-next-line:max-line-length
  'http://sfgov.org/olse/sites/default/files/FileCenter/Documents/11600-Art%20%2049%20Official%20Notice%20Final%20091114.pdf'

const FAIR_CREDIT_REPORTING_URL =
  // tslint:disable-next-line:max-line-length
  'https://www.ftc.gov/sites/default/files/documents/one-stops/credit-reporting/pdf-0096-fair-credit-reporting-act.pdf'

const ARTICLE_23_A_URL =
  'https://www.labor.ny.gov/formsdocs/wp/correction-law-article-23a.pdf'

const listItem = {
  display: 'list-item',
  tag: 'li',
}
const OrderedAlphaList = styled.ol`
  list-style-type: lower-alpha;
`
const LegalTitle = props => (
  <InlineChildren justifyContent={InlineChildren.Justification.Center}>
    <Text styles={Text.Styles.Bold32}>{props.children}</Text>
  </InlineChildren>
)

export const AdditionalDisclosuresDocument: React.SFC = () => (
  <StackChildren>
    <LegalTitle>{additionalDisclosure.title1()}</LegalTitle>
    <LegalText>{additionalDisclosure.text1_1()}</LegalText>
    <LegalText>{additionalDisclosure.text1_2()}</LegalText>
    <LegalTitle>{additionalDisclosure.title2()}</LegalTitle>
    <OrderedAlphaList>
      <LegalText {...listItem}>{additionalDisclosure.text2_1()}</LegalText>
      <LegalText {...listItem}>
        {additionalDisclosure.text2_2()}
        <ol>
          <LegalText {...listItem}>{additionalDisclosure.text2_3()}</LegalText>
          <LegalText {...listItem}>{additionalDisclosure.text2_4()}</LegalText>
          <LegalText {...listItem}>{additionalDisclosure.text2_5()}</LegalText>
        </ol>
      </LegalText>
      <LegalText {...listItem}>{additionalDisclosure.text2_6()}</LegalText>
      <LegalText {...listItem}>{additionalDisclosure.text2_7()}</LegalText>
      <LegalText {...listItem}>{additionalDisclosure.text2_8()}</LegalText>
      <LegalText {...listItem}>{additionalDisclosure.text2_9()}</LegalText>
    </OrderedAlphaList>
    <LegalTitle>{additionalDisclosure.title3()}</LegalTitle>
    <LegalText>{additionalDisclosure.text3_1()}</LegalText>
    <LegalText>{additionalDisclosure.text3_2()}</LegalText>
    <LegalTitle>{additionalDisclosure.title4()}</LegalTitle>
    <LegalText>
      <Interpolate
        i18n={i18n}
        i18nKey={i18nKeys.documentAcceptanceModal__additionalDisclosureText4_1}
        components={[
          <a href={ARTICLE_23_A_URL} target="_blank">
            ##here##
          </a>,
        ]}
      />
    </LegalText>
    <LegalText>{additionalDisclosure.text4_2()}</LegalText>
    <LegalTitle>{additionalDisclosure.title5()}</LegalTitle>
    <LegalText>
      <Interpolate
        i18n={i18n}
        i18nKey={i18nKeys.documentAcceptanceModal__additionalDisclosureText5_1}
        components={[
          <a href={FAIR_CHANCE_ORDINANCE_NOTICE_URL} target="_blank">
            ##here##
          </a>,
        ]}
      />
    </LegalText>
    <LegalTitle>{additionalDisclosure.title6()}</LegalTitle>
    <LegalText>
      <Interpolate
        i18n={i18n}
        i18nKey={i18nKeys.documentAcceptanceModal__additionalDisclosureText6_1}
        components={[
          <a href={FAIR_CREDIT_REPORTING_URL} target="_blank">
            ##here##
          </a>,
        ]}
      />
    </LegalText>
  </StackChildren>
)

export default AdditionalDisclosuresDocument
